import React, { useState, useEffect, useRef } from "react";
import * as API from "../../api.js";
import {
  checkSubscriptionAndStorage,
  addUserAnalytic,
  updateOutTime,
  getPicstorkDefaultPlan,
  Popup,
} from "../../ReusableComponents/reusableFunctions";
import SideBarNew from "../../SideBarNew";
import { activesubscription } from "../../redux";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ArcElement,
} from "chart.js";
import AppConstants from "../../AppConstants";
import {
  getActiveTeam,
  getFeaturesPermissions,
  PICSTORK_FEATURES,
} from "../../Teams";
import { ManageProjectAccess } from "../../Teams/ManageProjectAccess";
import TopBarNew from "../../TopBarNew.js";
import MenuIcon from "../../icons/MenuIcon.svg";
import TowerIcon2 from "../../icons/TowerIcon2.svg";
import Search from "../../Icon/Search.png";
import TableView from "../../ReusableComponents/TableView/TableView.js";
import Viewbuttons from "../../ReusableComponents/ViewButtons/index.js";
import ButtonWithIcon from "../../ReusableComponents/ButtonWithIcon.js";
import Plus from "../../assets/Icons/plus.png";
import whitePlus from "../../assets/Icons/whiteplus.png";
import CreateTower from "./CreateTower.js";
import { TowerCard } from "../../ReusableComponents/Tower Card/TowerCard.js";
import { useHistory } from "react-router-dom";
import LoaderComponent from "../../ReusableComponents/LoaderComponent.js";
import DetailedReport from "./TowerDetailedReport";
import ImageSlider from "./TowerImageSlider";
import EditTowerStats from "./EditTowerStats.js";
import { useLocation } from "react-router-dom";
import ProgressBar from "./ReusableComp/ProgressBarProp.js";

const TotalProject = (props) => {
  const [user, setUser] = useState({});
  const [type, setType] = useState("");
  const [projects, setProjects] = useState([]);
  const [showBackIcon, setShowBackIcon] = useState(true);
  const [sidebarMode, setSidebarMode] = useState(
    props?.location?.state?.sidebarMode || "shrunk"
  );
  const [outId, setOutId] = useState("");
  const [selectedMangeAccessProject, setSelectedMangeAccessProject] =
    useState(false);
  const [selectedProjectData, setSelectedProjectData] = useState(undefined);
  const [showSubscriptionExpirePopup, setShowSubscriptionExpirePopup] =
    useState(false);
  const [key, setKey] = useState("");
  const [counts, setCounts] = useState(0);
  const [imageCollection, setImageCollection] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tableState, setTableState] = useState({
    pageSize: 10,
    pageNumber: 1,
    orderBy: undefined,
    orderType: undefined,
  });
  const [globalState, setGlobalState] = useState({
    selectView: "list",
  });
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const history = useHistory();
  const params = new URLSearchParams(history.location.search);

  const [detectionPollingTaskId, setDetectionPollingTaskId] = useState(null);
  const [pollingIntervalId, setPollingIntervalId] = useState(null);
  const [completedTasksMap, setCompletedTasksMap] = useState({});
  const [currentView, setCurrentView] = useState("main");
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [imageSliderData, setImageSliderData] = useState(null);
  const [permissions, setPermissions] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [isLoadingTasks, setIsLoadingTasks] = useState(false);
  const [selectedDetected, setselectedDetected] = useState([]);
  const query = new URLSearchParams(useLocation().search);
  const fromDashBoard = query.get("fromDashBoard") === "true" || false;

  const handleStateChange = (key, value) => {
    setGlobalState((prev) => ({
      ...prev,
      [key]: value,
    }));

    if (key === "selectView" && value === "grid") {
      setTableState((prev) => ({
        ...prev,
        pageNumber: 1,
      }));
    }
  };

  //   const activities = {
  //     canEdit: true,
  //     onClickEdit: (row) => {
  //       setIsEditModalOpen(true);
  //       setSelectedProject(row);
  //     },
  //     canDelete: true,
  //     onClickDelete: (row) => console.log("Delete", row),
  //   };

  // ---- Lifecycle: componentWillUnmount
  useEffect(() => {
    return () => {
      updateOutTime(outId);
      localStorage.removeItem("created_task");

      if (pollingIntervalId) {
        clearInterval(pollingIntervalId);
      }
    };
  }, [outId, pollingIntervalId]);

  // ---- Lifecycle: componentWillMount
  useEffect(() => {
    document.title = "PicStork - Dashboard";
    ChartJS.register(
      BarElement,
      CategoryScale,
      ArcElement,
      LinearScale,
      PointElement,
      LineElement,
      Title,
      Tooltip,
      Legend,
      Filler
    );

    getActiveTeam().then((activeTeam) => {
      // ✅ check subscription
      checkSubscriptionAndStorage(AppConstants.SERVICES.PICSTORK).then(
        (data) => {
          if (
            data.error ||
            data.storageExceed ||
            data.isExpired ||
            !data.isValidStoragePlan
          ) {
            setShowSubscriptionExpirePopup({
              ...data,
              user: props?.location?.state?.user,
            });
          } else {
            setShowSubscriptionExpirePopup(false);
          }
        }
      );

      // ✅ Analytics
      addUserAnalytic(props.location.pathname).then((id) => {
        setOutId(id);
      });

      if (props.location.state) {
        const { user, type, sidebarMode } = props.location.state;
        setUser(user || {});
        setSidebarMode(sidebarMode || "shrunk");
        setType(type || "");

        API.getUserSubbedServices().then((response) => {
          let services = response[0];
          if (services.length === 1 && services[0].title === "AeroStream") {
            setShowBackIcon(false);
          } else {
            setShowBackIcon(true);
          }
        });
      } else {
        API.getUserType().then(
          ([blah, type, user]) => {
            setUser(user);
            setType(type);
          },
          () => {
            window.location.replace("/login");
          }
        );
      }
    });
  }, []);

  // Fetch permissions
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const featuresList = [
          PICSTORK_FEATURES.IMAGECOLLECTIONS,
          PICSTORK_FEATURES.ANNOTATIONS,
          PICSTORK_FEATURES.TASKS,
          PICSTORK_FEATURES.REPORTS,
        ];

        const perms = await getFeaturesPermissions(featuresList);
        setPermissions(perms);
      } catch (error) {
        console.error("Error fetching permissions:", error);
        setPermissions({
          container: "",
          st: "",
          [PICSTORK_FEATURES.REPORTS]: { DOWNLOAD: true },
          [PICSTORK_FEATURES.TASKS]: { READ: true },
        });
      }
    };

    if (user?.username) {
      fetchPermissions();
    }
  }, [user]);

  // ---- Sidebar Config
  const sidebarConfigurations = {
    options: showBackIcon
      ? [
          { icon: MenuIcon, text: "Home", path: "/picstork/dashboard" },
          { icon: TowerIcon2, text: "Projects", path: "/picstork/towers" },
        ]
      : null,
    user,
    type,
    mode: sidebarMode,
    picStorkHelp: true,
  };

  const topbarConfigurations = {
    options: showBackIcon
      ? [
          {
            icon: MenuIcon,
            text: "Dashboard",
            path: "/picstork/dashboard",
          },
          { icon: MenuIcon, text: "Total Projects", path: "/picstork/total-projects" },
        ]
      : null,
    user,
    type,
    mode: sidebarMode,
    picStorkHelp: true,
  };

  function useDebounce(value, delay = 500) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
      const handler = setTimeout(() => setDebounced(value), delay);
      return () => clearTimeout(handler);
    }, [value, delay]);
    return debounced;
  }

  const debouncedKey = useDebounce(key, 500);

  const columns = [
    { Header: "Name", accessor: "project_name", isSortable: true },
    {
      Header: "Created",
      accessor: "created_date",
      isSortable: true,
    },
    {
      Header: "Description",
      accessor: "description",
      isSortable: true,
    },
  ];

  const fetchProjects = async () => {
    try {
      setIsLoading(true);
      const pageNumber = Math.floor(tableState.pageNumber - 1);

      const response = await API.getAllProjects(
        key || " ",
        globalState.selectView == "list" ? 10 : 10000,
        pageNumber,
        null,
        "PicStork",
        null,
        null,
        tableState.orderBy,
        tableState.orderType
      );

      const formatted = (response.projects || response).map((p) => ({
        id: p.id,
        project_name: p.project_name,
        created_date: p.created_date
          ? new Date(p.created_date).toISOString().split("T")[0]
          : "—",
        description: p.description || "—",
        current_status: p.current_status
          ? p.current_status.charAt(0).toUpperCase() +
            p.current_status.slice(1).toLowerCase()
          : "-" || "—",
        total_installed: p.total_installed || "0",
        completed_towers: p.completed_towers || "0",
        in_progress_towers: p.in_progress_towers || "0",
        pending_towers: p.pending_towers || "0",
        energy: p.energy_consumed || "0",
        images: p.images || 0,
        detections: p.detections || 0,
        location: p.location_name || "—",
        capacity: p.capacity || "0",
        task_status: p.task_status,
      }));

      setProjects(formatted);
      setCounts(response.count || formatted.length);

      if (history.location.search) {
        let projectData = formatted.find((p) => p.id === params.get("id"));

        if (projectData) {
          handleRowClick(projectData);
        }
      }
    } catch (err) {
      console.error("Error fetching projects:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const updateProjectStats = async (data) => {
    try {
      let { completed, currentStatus, inProgress, pending, totalInstalled } =
        data;
      const response = await API.updateProjectStats(
        selectedProject.id,
        totalInstalled,
        completed,
        inProgress,
        pending,
        currentStatus
      );

      Popup.alert(
        "SUCCESS",
        response.message || "Project stats updated successfully",
        "OK",
        () => {
          fetchProjects();
          Popup.close();
        }
      );
      if (response) {
        console.log("Project stats updated successfully:", response);
      }
    } catch (error) {
      Popup.alert(
        "ERROR",
        error.message || "Error updating project stats",
        "OK",
        () => {
          Popup.close();
        }
      );
    }
  };

  useEffect(() => {
    fetchProjects();
  }, [tableState, isCreateModalOpen, debouncedKey, globalState.selectView]);

  const handleRowClick = async (row) => {
    try {
      const tasks = [];

      const hasCompletedTask = tasks.some(
        (task) => task.status === AppConstants.TASK.STATUS.COMPLETED
      );
    } catch (err) {
      console.error("Error handling row click:", err);
    }
  };

  return user?.username ? (
    <div className="wrapper">
      <ManageProjectAccess
        projectId={selectedMangeAccessProject}
        closeManageAccess={() => {
          setSelectedMangeAccessProject(false);
          setSelectedProjectData(undefined);
        }}
        senderData={user}
        propsData={selectedProjectData}
      />

      <SideBarNew
        config={sidebarConfigurations}
        showMainDashboardIcons={showBackIcon}
        parentSidebarSwitch={() =>
          setSidebarMode(sidebarMode === "shrunk" ? "expanded" : "shrunk")
        }
      />

      <div
        className="right-content"
        style={{ backgroundColor: "#EAEDF0" }}
        onClick={() => setSidebarMode("shrunk")}
      >
        <TopBarNew config={topbarConfigurations} />

        <div
          className="main-content"
          style={{
            background: "none",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginTop: "20px",
            height: "calc(100vh - 80px)",
          }}
        >
          <>
            <div
              className="slide"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
                alignItems: "center",
              }}
            >
              <>
                <div
                  className="services-content-title"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#1F1C45",
                    fontWeight: 600,
                  }}
                >
                  Total Projects ({counts})
                </div>

                <CreateTower
                  isOpen={isCreateModalOpen}
                  onRequestClose={() => setIsCreateModalOpen(false)}
                  onSubmit={(newTower) => {}}
                />

                {isEditModalOpen && (
                  <EditTowerStats
                    isOpen={isEditModalOpen}
                    initialData={selectedProject}
                    onRequestClose={() => setIsEditModalOpen(false)}
                    onSubmit={(updatedTower) => {
                      updateProjectStats(updatedTower);
                    }}
                  />
                )}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    paddingRight: "8px",
                  }}
                >
                  <div>
                    <img
                      src={Search}
                      style={{
                        height: "20px",
                        width: "20px",
                        position: "relative",
                        left: "25px",
                      }}
                    />
                    <input
                      type="text"
                      value={key}
                      className="add-user-form-text2"
                      placeholder="Search"
                      style={{
                        height: "30px",
                        width: "230px",
                        paddingLeft: "28px",
                        border: "1px solid rgba(102, 102, 102, 0.3)",
                      }}
                      onChange={(e) => setKey(e.target.value)}
                    />
                  </div>
                </div>
              </>
              {/* )} */}
            </div>

            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "50px",
                }}
              >
                <LoaderComponent />
              </div>
            ) : globalState.selectView === "list" ? (
              <TableView
                columns={columns}
                data={projects}
                isLoading={false}
                showSrNo={true}
                count={counts}
                onStateChange={setTableState}
                pageNumber={tableState.pageNumber}
                onClickRow={(row) => {
                  history.push(`/picstork/total-towers`, {
                    rowData: row,
                  });
                }}
              />
            ) : (
              <></>
            )}
          </>
        </div>
      </div>
    </div>
  ) : (
    <div />
  );
};

// Redux
const mapDispatchToProps = (dispatch) => ({
  activesubscription: (payload) => dispatch(activesubscription(payload)),
});

const mapStateToProps = (state) => ({
  SubscriptionData: state.subscription.subscriptionData,
});

export default connect(mapStateToProps, mapDispatchToProps)(TotalProject);
